module.exports = __webpack_public_path__ + "img/mem_coupon_font2_m.74d95184.jpg";